import { PruHttpService } from "../../services/pru-http.service";
import { Observable, of, BehaviorSubject } from 'rxjs';
import { map, catchError } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "../../services/pru-http.service";
var TwoFactorAuthService = /** @class */ (function () {
    function TwoFactorAuthService(_pruHttp) {
        this._pruHttp = _pruHttp;
        this._hrtFlag = "";
        this._redirectUrl = "";
        this.attemptCounter = 3;
        this.success = [];
        this.error = [];
        this.loading = true;
        this.checkingHRT = true;
        this.checking2Foption = true;
        this.boolean = false;
        this._payloadData = {
            hrtContactChannel: {},
            hrtContactStatus: "",
            hrtContactValue: "",
            contact: {
                phone: "",
                email: "",
                type: ""
            }
        };
        this.promptSubject = new BehaviorSubject("");
    }
    // getHrtValue() {
    //   const hrtUrl = "/onprem/api/co/secure/hrt";
    //   return this._pruHttp.get(hrtUrl, "Hrtservice");
    // }
    TwoFactorAuthService.prototype.getTwoFactorStatus = function () {
        var _this = this;
        var url = "/api/secure/platform/selfservicesecureauth/v1/2Foptin";
        return this._pruHttp.get(url, "service").pipe(map(function (data) {
            if (data && data.contactChannels && data.contactChannels.length > 0) {
                _this.createPayloadData(data.contactChannels);
                _this.checking2Foption = false;
            }
            return data;
        }), catchError(function (error) { return of(error); }));
    };
    TwoFactorAuthService.prototype.disableTwoFactor = function () {
        var url = "/api/secure/platform/selfservicesecureauth/v1/2Foptin";
        var postData = {
            optINFlag: "false"
        };
        return this._pruHttp.post(url, "service", postData);
    };
    TwoFactorAuthService.prototype.getHrtAuth = function () {
        var _this = this;
        var url = "/api/secure/platform/selfservicesecure/v1/hrtAuth";
        return this._pruHttp.get(url, "service").pipe(map(function (data) {
            _this._hrtFlag = data.hrtFlag.toLowerCase();
            _this.checkingHRT = false;
            return data;
        }));
    };
    TwoFactorAuthService.prototype.getPayLoadData = function () {
        return this._payloadData;
    };
    TwoFactorAuthService.prototype.getHrtFlag = function () {
        return this._hrtFlag;
    };
    TwoFactorAuthService.prototype.setRedirectUrl = function (url) {
        this._redirectUrl = url;
    };
    TwoFactorAuthService.prototype.getRedirectUrl = function () {
        return this._redirectUrl;
    };
    TwoFactorAuthService.prototype.sendMessage = function (message) {
        this.promptSubject.next({ text: message });
    };
    TwoFactorAuthService.prototype.getMessage = function () {
        return this.promptSubject.asObservable();
    };
    TwoFactorAuthService.prototype.createPayloadData = function (contactChannels) {
        this._payloadData.hrtContactChannel = contactChannels[0];
        this._payloadData.hrtContactValue = contactChannels[0].contactChannelValue;
        this._payloadData.hrtContactStatus = contactChannels[0].contactStatus;
        this._payloadData.contact.type = contactChannels[0].contactChannelCode;
        this._payloadData.contact.email = (contactChannels.filter(function (contact) {
            return contact.contactChannelCode.toLowerCase() === "email";
        })[0] || []).contactChannelCode;
        this._payloadData.contact.phone = (contactChannels.filter(function (contact) {
            return contact.contactChannelCode.toLowerCase() === "phone";
        })[0] || []).contactChannelCode;
    };
    TwoFactorAuthService.prototype.sendOneTimeCode = function (sourceApp) {
        var url = "/api/secure/platform/selfservicesecureauth/v1/verifyContact";
        var postData = {
            sourceApplication: sourceApp
        };
        var payloadData = this.getPayLoadData();
        if (payloadData.contact.type === "PHONE") {
            postData["deliveryMethod"] = "sms";
            postData["phNum"] = payloadData.hrtContactValue;
        }
        else if (payloadData.contact.type === "EMAIL") {
            postData["deliveryMethod"] = "email";
            postData["emailId"] = payloadData.hrtContactValue;
        }
        return this._pruHttp.post(url, "service", postData);
    };
    TwoFactorAuthService.prototype.verifyOneTimeCode = function (code, sourceApp) {
        var postData = {
            sourceApplication: sourceApp,
            confirmCode: code
        };
        var url = "/api/secure/platform/selfservicesecureauth/v1/validateResetCode";
        return this._pruHttp.post(url, "service", postData);
    };
    TwoFactorAuthService.prototype.logout = function () {
        var _1Minutes = new Date(new Date().getTime() + 1 * 1000 * 60);
        var logoutUrl = (window.document.cookie.match(/MYACCTLOGOUT=([^;]*)/) ||
            [])[1];
        window.sessionStorage.clear();
        document.cookie =
            "X-PruAccountHardLocked=true;domain=.prudential.com;path=/;SameSite=Lax;Secure;expires=" +
                _1Minutes.toUTCString();
        window.location.replace(logoutUrl);
    };
    TwoFactorAuthService.ngInjectableDef = i0.defineInjectable({ factory: function TwoFactorAuthService_Factory() { return new TwoFactorAuthService(i0.inject(i1.PruHttpService)); }, token: TwoFactorAuthService, providedIn: "root" });
    return TwoFactorAuthService;
}());
export { TwoFactorAuthService };
